<template>
  <line-chart :chartData="chartData" :options="chartOptions" />
</template>

<script>
import LineChart from "@/components/base/charts/lineChart";
export default {
  props: {
    data: { type: Object, default: { headers: [], rows: [] } },
  },
  data() {
    return {
      chartOptions: {
        title: {
          display: true,
          text: "Impression",
          fontSize: 24,
        },
        legend: {
          display: true,
          align: "start",
          labels: {
            fontSize: 16,
          },
        },
        scales: {
          xAxes: [
            {
              ticks: {
                padding: 10,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                padding: 10,
              },
              offset: true,
            },
          ],
        },
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 0,
            bottom: 0,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  components: {
    LineChart,
  },
  computed: {
    chartData() {
      let impressionObj = {};
      _.forEach(_.sortBy(this.data.rows, "representive"), (row) => {
        impressionObj[row.representive] = impressionObj.hasOwnProperty(
          row.representive
        )
          ? impressionObj[row.representive] + row.impressions
          : row.impressions;
      });
      let data = {
        labels: _.keys(impressionObj),
        datasets: [
          {
            label: "Impression",
            data: _.values(impressionObj),
            borderColor: "#EF767A",
            pointBackgroundColor: "#EF767A",
            pointBorderColor: "#fff",
            fill: false,
            lineTension: 0,
          },
        ],
      };
      return data;
    },
  },
};
</script>

<style></style>
